import axios from "axios";
import config from "../../../config";

const baseUrl = config.baseUrl;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

const dataDashboard = {
  getDataDahboard: async () => {
    try {
      const response = await axiosInstance.get('/api/resumenDashboard');
      return response.data;
    } catch (error) {
      console.error('Error al obtener datos del dashboard:', error);
      throw error;
    }
  },
};

export default dataDashboard;
